import Splide from '@splidejs/splide'; //? https://splidejs.com/
import GLightbox from 'glightbox/dist/js/glightbox.js'; //? https://github.com/biati-digital/glightbox

document.addEventListener( 'DOMContentLoaded', function () {
	initProductGallery()
});

export function initProductGallery(){
    var prodCarousel = document.querySelector(".prod-main-carousel");
	
    if(prodCarousel){

        var prodMainCarousel = new Splide( '.prod-main-carousel', {
            type       : 'fade',
            pagination : false,
            arrows     : false,
            cover      : true,
        });
        
        var prodThumbnails = document.querySelector(".prod-thumbnails");

        if(prodThumbnails){
    
            var prodThumbs = new Splide( '.prod-thumbnails', {
                type: 'slide',
                arrows: false,
                gap: 10,
                perPage: 4,
                perMove: 1,
                cover: true,
                isNavigation: true,
                pagination: false,
            }).mount();

            prodMainCarousel.sync( prodThumbs ).mount();

        }else{
            prodMainCarousel.mount();
        }

    }

	// Light box
	var lightbox = GLightbox({
		touchNavigation: true, 
		loop: true,
	});	
}